<proffeo-ui-dialog [title]="'task-description-acknowledgement-panel.require-again-title' | translate">
  <p class="text-base">
    {{ 'task-description-acknowledgement-panel.require-again-description' | translate }}
  </p>
  <div
    dialog-actions
    class="flex w-full justify-end gap-2"
  >
    <proffeo-ui-button
      (clicked)="close(false)"
      variant="primary"
      text="task-description-acknowledgement-panel.require-again-no"
    ></proffeo-ui-button>
    <proffeo-ui-button
      (clicked)="close(true)"
      variant="accent"
      text="task-description-acknowledgement-panel.require-again-yes"
    ></proffeo-ui-button>
  </div>
</proffeo-ui-dialog>
